<template>
  <DashboardLayout>
    <template slot="navbarFilters">
      <div v-if="hasWorldStore && !loadingApiData" class="navbar-filters">
        <div v-if="sellerAccountsList && sellerAccountsList.length > 0" class="ui dropdown filter-dropdown navbar-dropdown" ref="saDropdown">
          <div class="dropdown-trigger">
            <span class="text">S.Accounts: {{ filterBySellAcc.length === 0 ? 'All' : filterBySellAcc.length + ' selected' }}</span>
            <i class="dropdown icon"></i>
          </div>
          <div class="menu">
            <div class="item" :class="{ selected: filterBySellAcc.length === 0 }" data-value="">
              <i class="check icon" v-if="filterBySellAcc.length === 0"></i>
              All
            </div>
            <div class="divider"></div>
            <div v-for="sa in sellerAccountsList" :key="sa.sellerId" class="item" :class="{ selected: filterBySellAcc.indexOf(sa.sellerId) >= 0 }" :data-value="sa.sellerId">
              <i class="check icon" v-if="filterBySellAcc.indexOf(sa.sellerId) >= 0"></i>
              {{ sa.accountNickName }}
            </div>
          </div>
        </div>
        <div v-if="filterUserCountries && filterUserCountries.length > 0" class="ui dropdown filter-dropdown navbar-dropdown" ref="marketplaceDropdown">
          <div class="dropdown-trigger">
            <span class="text">Marketplaces: {{ filterByMarket.length === 0 ? 'All' : filterByMarket.length === 1 ? filterByMarket[0] : filterByMarket.length + ' selected' }}</span>
            <i class="dropdown icon"></i>
          </div>
          <div class="menu">
            <div class="item" :class="{ selected: filterByMarket.length === 0 }" data-value="">
              <i class="check icon" v-if="filterByMarket.length === 0"></i>
              All
            </div>
            <div class="divider"></div>
            <div v-for="c in filteredCountries" :key="c" :class="[c=='s' ? 'divider' : 'item', { selected: filterByMarket.indexOf(c) >= 0 && c !== 's' }]" :data-value="c">
              <i class="check icon" v-if="filterByMarket.indexOf(c) >= 0 && c !== 's'"></i>
              <i v-if="c!='s'" :class="c.toLowerCase().replace('uk','gb')+' flag'" style="margin-right: 8px;"></i>
              <span v-if="c!='s'">Amazon.{{ getMarketplaceSuffix(c) }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  <div class="products-page">
    <div class="products-content">
      <div v-if="hasWorldStore && !loadingApiData" class="toolbar">
        <div class="toolbar-title-group">
          <span class="toolbar-title">Products</span>
          <span class="stat-pill total">{{ totalProducts }} total</span>
          <span class="stat-pill cogs-ok">{{ cogsSetCount }} COGS set</span>
          <span class="stat-pill cogs-missing">{{ cogsMissingCount }} missing</span>
        </div>
        <div class="toolbar-gap"></div>
        <div class="search-wrap">
          <span class="search-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"></circle><path d="M21 21l-4.35-4.35"></path></svg>
          </span>
          <input
            type="search"
            v-model="asinSearch"
            v-prevent-autofill="asinSearch"
            @keyup.enter="handleAsinSearch"
            placeholder="Search products or ASIN…"
            class="search-input">
          <i v-if="asinSearch" class="times circle icon clear-search" @click="clearAsinSearch"></i>
        </div>
        <button
          class="quick-filter"
          :class="{ active: filterByBuyBox }"
          @click="toggleBuyBoxFilter">
          Buy Box: All
        </button>
        <button
          class="quick-filter"
          :class="{ active: filterMissingCogs }"
          @click="toggleMissingCogsFilter">
          Missing COGS <span class="qf-count">{{ cogsMissingCount }}</span>
        </button>
        <button class="btn-import" @click="handleImportCogs">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
          Import COGS
        </button>
        <div class="view-toggle">
          <button
            class="view-btn"
            :class="{ active: viewMode === 'grid' }"
            @click="viewMode = 'grid'"
            title="Grid view">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="3" width="7" height="7" rx="1"></rect><rect x="3" y="14" width="7" height="7" rx="1"></rect><rect x="14" y="14" width="7" height="7" rx="1"></rect></svg>
          </button>
          <button
            class="view-btn"
            :class="{ active: viewMode === 'table' }"
            @click="viewMode = 'table'"
            title="Table view">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          </button>
        </div>
      </div>
    </div>

      <div id="prodCont" key="2" class="ui fluid container">
        <!-- Loading State -->
        <div v-if="loadingApiData || !hasWorldStore" class="ui active centered inline loader" style="margin: 50px 0;"></div>
        <!-- Error State -->
        <div v-if="apiError && !loadingApiData" class="ui error message" style="margin: 20px 0;">
          <div class="header">Failed to Load Products</div>
          <p>{{ apiError }}</p>
          <button class="ui button" @click="loadProductsFromBackend()">Retry</button>
        </div>
        <transition name="fadeLeft" mode="out-in" appear>
          <ProductCard
            v-if="productData && productData.products && Object.keys(productData.products).length > 0 && viewMode === 'grid' && !loadingApiData"
            :key="'grid-' + gridCurrentPage"
            ref="productCard"
            :worldStore="productData"
            :filterByMarket="filterByMarket"
            :filterBySellAcc="filterBySellAcc"
            :filterMissingCogs="filterMissingCogs"
            @open-product-details="showProductDetails"
            @cogs-updated="handleCogsUpdated"/>
        </transition>

        <!-- Table view -->
        <div v-if="productData && productData.products && Object.keys(productData.products).length > 0 && viewMode === 'table' && !loadingApiData" class="table-view" id="tableView">
          <div class="products-table-wrap">
            <table>
              <thead>
                <tr>
                  <th class="th-img"></th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('product')"
                      role="button"
                      tabindex="0"
                      title="Sort by product name or ASIN"
                      @click.stop="toggleTableSort('product')"
                      @keydown.enter.prevent="toggleTableSort('product')"
                    >Product / ASIN<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'product' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'product' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('buyBox')"
                      role="button"
                      tabindex="0"
                      title="Sort by Buy Box status"
                      @click.stop="toggleTableSort('buyBox')"
                      @keydown.enter.prevent="toggleTableSort('buyBox')"
                    >Buy Box<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'buyBox' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'buyBox' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('rating')"
                      role="button"
                      tabindex="0"
                      title="Sort by star rating"
                      @click.stop="toggleTableSort('rating')"
                      @keydown.enter.prevent="toggleTableSort('rating')"
                    >Rating<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'rating' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'rating' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('salesYesterday')"
                      role="button"
                      tabindex="0"
                      title="Sort by units sold yesterday"
                      @click.stop="toggleTableSort('salesYesterday')"
                      @keydown.enter.prevent="toggleTableSort('salesYesterday')"
                    >Sales (ystd.)<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'salesYesterday' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'salesYesterday' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('salesToday')"
                      role="button"
                      tabindex="0"
                      title="Sort by units sold today"
                      @click.stop="toggleTableSort('salesToday')"
                      @keydown.enter.prevent="toggleTableSort('salesToday')"
                    >Sales (today)<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'salesToday' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'salesToday' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('cogs')"
                      role="button"
                      tabindex="0"
                      title="Sort by COGS"
                      @click.stop="toggleTableSort('cogs')"
                      @keydown.enter.prevent="toggleTableSort('cogs')"
                    >COGS<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'cogs' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'cogs' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th class="th-sort">
                    <span
                      class="sort-col-head"
                      :class="tableSortHeadClass('margin')"
                      role="button"
                      tabindex="0"
                      title="Sort by margin %"
                      @click.stop="toggleTableSort('margin')"
                      @keydown.enter.prevent="toggleTableSort('margin')"
                    >Margin<span class="sort-col-icons" aria-hidden="true">
                      <svg v-if="tableSortKey === 'margin' && tableSortDir === 'asc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8l7 9H5z"/></svg>
                      <svg v-else-if="tableSortKey === 'margin' && tableSortDir === 'desc'" class="sort-icon-filled" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16l-7-9h14z"/></svg>
                      <svg v-else class="sort-icon-neutral" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>
                    </span></span>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in tableProducts" :key="product.productId" @click="showProductDetails(product.productId)" :class="{ 'cogs-missing-row': !(product.cogs && parseFloat(product.cogs) > 0) }" class="clickable-row">
                  <td>
                    <div class="product-thumb">
                      <img v-if="product.largeImageUrl" :src="product.largeImageUrl" alt="">
                      <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="7" width="20" height="14" rx="2"></rect><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"></path></svg>
                    </div>
                  </td>
                  <td>
                    <div class="product-cell">
                      <div class="product-info">
                        <div class="product-name">{{ product.productTitle }}</div>
                        <div class="product-meta"><span class="product-asin">{{ getAsin(product) }}</span> <span class="market-tag">{{ getMarketplaceEmoji((product.marketplace || '').toUpperCase()) }} {{ product.marketplace || '—' }}</span></div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span v-if="getBuyBoxStatus(product)" class="bb-badge" :class="getTableBuyBoxClass(getBuyBoxStatus(product))">{{ getBuyBoxStatusLabel(getBuyBoxStatus(product)) }}</span>
                    <span v-else class="bb-badge unknown">—</span>
                  </td>
                  <td>
                    <span class="rating-cell" :class="{ 'rating-unknown': ratingSummary(product.rating, product.reviewCount) === '—' }">{{ ratingSummary(product.rating, product.reviewCount) }}</span>
                    <span
                      v-if="product.reviewHealthStatus === 'red'"
                      class="rating-alert-dot"
                      :title="product.reviewHealthNote || 'Review Health alert'"
                      :aria-label="product.reviewHealthNote || 'Review Health alert'"
                      role="img"
                    ></span>
                  </td>
                  <td>
                    <div class="sales-primary">{{ product.salesYesterday || 0 }} units</div>
                    <div class="sales-sub">Yesterday</div>
                  </td>
                  <td>
                    <div class="sales-primary">{{ product.salesToday || 0 }} units</div>
                    <div class="sales-sub">So far today</div>
                  </td>
                  <td @click.stop>
                    <span
                      v-if="hasProductCogs(product)"
                      class="cogs-val cogs-val-editable"
                      role="button"
                      tabindex="0"
                      title="Edit COGS"
                      @click.prevent="openCogsModal(product)"
                    >${{ formatPrice(getProductCogs(product)) }}</span>
                    <span v-else class="cogs-empty">Not set</span>
                  </td>
                  <td @click.stop>
                    <template v-if="hasProductCogs(product)">
                      <span
                        v-if="getProductMargin(product) != null"
                        class="margin-pill cogs-val-editable"
                        :class="getMarginClass(getProductMargin(product))"
                        role="button"
                        tabindex="0"
                        title="Edit COGS"
                        @click.prevent="openCogsModal(product)"
                      >{{ getProductMargin(product) }}%</span>
                      <span
                        v-else
                        class="margin-pill low cogs-val-editable"
                        role="button"
                        tabindex="0"
                        title="Edit COGS"
                        @click.prevent="openCogsModal(product)"
                      >—</span>
                      <div class="table-edit-cogs-wrap">
                        <span class="add-cogs" @click.prevent="openCogsModal(product)">Edit COGS</span>
                      </div>
                    </template>
                    <span v-else class="add-cogs" @click.prevent="openCogsModal(product)">+ Add COGS</span>
                  </td>
                  <td @click.stop.prevent="openChartModal(product)">
                    <div class="action-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination for table view -->
        <div class="ui center aligned segment products-pagination-segment">
          <div class="ui pagination menu">
              <a class="item" :class="{ disabled: gridCurrentPage === 0 }" @click="tablePrevPage()">
              <i class="left chevron icon"></i>
            </a>

              <a v-for="page in Math.min(5, gridTotalPages)" :key="page"
               class="item"
                 :class="{ active: gridCurrentPage === getTablePageNumber(page) }"
                 @click="goToTablePage(getTablePageNumber(page))">
                {{ getTablePageNumber(page) + 1 }}
              </a>

              <a class="item" :class="{ disabled: gridCurrentPage >= (gridTotalPages - 1) }" @click="tableNextPage()">
              <i class="right chevron icon"></i>
            </a>
          </div>

          <div class="ui small message" style="margin-top: 10px;">
              Showing page {{ gridCurrentPage + 1 }} of {{ gridTotalPages }}
              ({{ gridTotalItems }} total products)
            </div>
          </div>
        </div>

        <div v-if="hasWorldStore && viewMode === 'grid'" class="ui center aligned segment products-pagination-segment">
          <div class="ui pagination menu">
            <a class="item" :class="{ disabled: gridCurrentPage === 0 }" @click="prevGridPage()">
              <i class="left chevron icon"></i>
            </a>

            <a v-for="page in Math.min(5, gridTotalPages)" :key="page"
               class="item"
               :class="{ active: gridCurrentPage === getGridPageNumber(page) }"
               @click="goToGridPage(getGridPageNumber(page))">
              {{ getGridPageNumber(page) + 1 }}
            </a>

            <a class="item" :class="{ disabled: gridCurrentPage >= (gridTotalPages - 1) }" @click="nextGridPage()">
              <i class="right chevron icon"></i>
            </a>
          </div>

          <div class="ui small message" style="margin-top: 10px;">
            Showing page {{ gridCurrentPage + 1 }} of {{ gridTotalPages }}
            ({{ gridTotalItems }} total products)
          </div>
        </div>
      </div>
    </div>

    <ProductDetails ref="productDetails" />
    <ProductDetailsChartModal ref="chartModal" />
    <!-- COGS Modal for Table View -->
    <!-- Product Cost & Margin Modal for Table View -->
    <ProductCostMarginModal
      ref="tableProductCostMarginModal"
      @cost-margin-updated="handleTableCostMarginUpdated">
    </ProductCostMarginModal>
  </DashboardLayout>
</template>

<script>
import $ from 'jquery'
import { extractV1SellersItems, mapV1SellersToFilterAccounts, buildMarketplaceFilterCodes, buildMarketplaceFilterDropdownItems, MARKETPLACE_FILTER_COUNTRIES_ALL, getMarketplaceAmazonSuffix } from './utils/sellerAccountsFromV1Api.js'
import DashboardLayout from './components/buybox/DashboardLayout.vue'
import ProductCard from './components/ProductCard.vue'
import ProductTableView from './components/ProductTableView.vue'
import ProductDetails from './components/ProductDetails.vue'
import ProductCostMarginModal from './components/ProductCostMarginModal.vue'
import ProductDetailsChartModal from './components/ProductDetailsChartModal.vue'
import { buildProductDetailsQuery } from './utils/listViewUrlSync.js'
import productPricingMixin from './mixins/productPricingMixin.js'
import { ratingSummary } from './utils/reviewHealth.js'

const PRODUCTS_PAGE_STORAGE_KEY = 'sentrykit_products_page_state'

/** Client-side table sort keys (Products page, table view). */
const PRODUCTS_TABLE_SORT_KEYS = ['product', 'buyBox', 'rating', 'salesYesterday', 'salesToday', 'cogs', 'margin']

const PRODUCTS_URL_KEYS = ['marketplaces', 'sellerAccounts', 'q', 'missingCogs', 'buybox', 'view', 'page', 'sort', 'sortDir']

function shallowEqualProductsQuery (next, routeQuery) {
  for (let i = 0; i < PRODUCTS_URL_KEYS.length; i++) {
    const k = PRODUCTS_URL_KEYS[i]
    const nv = next[k] != null ? String(next[k]) : ''
    const rv = routeQuery && routeQuery[k] != null ? String(routeQuery[k]) : ''
    if (nv !== rv) return false
  }
  return true
}

export default {
  name: 'ProductsPage',
  mixins: [productPricingMixin],
  components: {
    DashboardLayout,
    ProductCard,
    ProductTableView,
    ProductDetails,
    ProductCostMarginModal,
    ProductDetailsChartModal
  },
  data() {
    return {
      lastUpdated: 'just now',
      lastUpdateTime: null,
      timerInterval: null,
      asinSearch: '',
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: MARKETPLACE_FILTER_COUNTRIES_ALL,
      filterUserCountries: [],
      filterShowSASelector: false,
      filterMissingCogs: false,
      filterByBuyBox: false,
      viewMode: 'grid',
      tableCurrentPage: 0,
      tableItemsPerPage: 20,
      // Grid pagination (server-side)
      gridCurrentPage: 0,
      gridPageSize: 20,
      gridTotalItems: 0,
      gridTotalPages: 1,
      // API data
      apiData: null,
      loadingApiData: false,
      apiError: null,
      _syncingDropdowns: false,
      /** `null` until first GET /api/v1/sellers completes; then array (possibly empty). */
      v1SellerAccountRows: null,
      /** Last GET /api/v1/sellers body — marketplace codes on connected storefronts. */
      v1SellersApiBody: null,
      _v1SellersPromise: null,
      /** Table view only: client-side sort; `null` = API order. Default: yesterday sales desc. */
      tableSortKey: 'salesYesterday',
      tableSortDir: 'desc',
      _applyingProductsRouteQuery: false,
      _productsUrlTimer: null
    }
  },
  computed: {
    filteredCountries() {
      return buildMarketplaceFilterDropdownItems(this.filterUserCountries, this.filterCountriesAll)
    },
    hasWorldStore() {
      if (this.apiData && this.apiData.products !== undefined) {
        return true
      }
      return this.$parent && this.$parent.worldStore && this.$parent.worldStore.products !== undefined
    },
    totalProducts() {
      // Use API summary if available
      if (this.apiData && this.apiData.summary) {
        return this.apiData.summary.totalProducts || 0
      }
      // Fall back to worldStore
      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.products) return 0
      return Object.keys(this.$parent.worldStore.products).length
    },
    cogsSetCount() {
      // Use API summary if available
      if (this.apiData && this.apiData.summary) {
        return this.apiData.summary.cogsSet || 0
      }
      // Fall back to worldStore
      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.products) return 0
      return Object.values(this.$parent.worldStore.products).filter(p => p.cogs && p.cogs > 0).length
    },
    cogsMissingCount() {
      // Use API summary if available
      if (this.apiData && this.apiData.summary) {
        return this.apiData.summary.missingCogs || 0
      }
      // Fall back to worldStore
      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.products) return 0
      return Object.values(this.$parent.worldStore.products).filter(p => !p.cogs || p.cogs === 0).length
    },
    sellerAccountsList() {
      const v1 = this.v1SellerAccountRows
      if (v1 != null && v1.length > 0) {
        return v1.map(r => ({
          sellerId: r.id,
          accountNickName: r.name,
          marketplace: r.marketplace
        }))
      }
      if (this.apiData && this.apiData.availableFilters && this.apiData.availableFilters.sellerAccounts) {
        console.log('Using seller accounts from availableFilters:', this.apiData.availableFilters.sellerAccounts)
        return this.apiData.availableFilters.sellerAccounts.map(sa => ({
          sellerId: sa.id,
          accountNickName: sa.name,
          marketplace: sa.marketplace
        }))
      }
      
      // Fallback: Extract unique seller accounts from products
      if (this.apiData && this.apiData.products) {
        const products = Object.values(this.apiData.products)
        const sellerMap = new Map()
        products.forEach(p => {
          if (p.sellerId && !sellerMap.has(p.sellerId)) {
            sellerMap.set(p.sellerId, {
              sellerId: p.sellerId,
              accountNickName: p.sellerName || `Account ${p.sellerId}`,
              marketplace: p.marketplace
            })
          }
        })
        const accounts = Array.from(sellerMap.values())
        console.log('Extracted seller accounts from products:', accounts)
        return accounts
      }
      
      // Fall back to worldStore
      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.sellerAccounts) return []
      return Object.values(this.$parent.worldStore.sellerAccounts)
    },
    filteredProducts() {
      let products = []
      // If we have API data, use it (filters already applied by backend)
      if (this.apiData && this.apiData.products) {
        products = Object.values(this.apiData.products)
      } else if (this.$parent && this.$parent.worldStore && this.$parent.worldStore.products) {
        // Fall back to worldStore with client-side filtering
        products = Object.values(this.$parent.worldStore.products)
        if (this.filterByMarket.length > 0) {
          products = products.filter(p => this.filterByMarket.indexOf(p.marketplace) >= 0)
        }
        if (this.filterBySellAcc.length > 0) {
          products = products.filter(p => this.filterBySellAcc.indexOf(p.sellerId) >= 0)
        }
        if (this.filterMissingCogs) {
          products = products.filter(p => !p.cogs || p.cogs === 0)
        }
      }
      return products
    },
    tableTotalPages() {
      // Use server-side pagination info
      return this.gridTotalPages
    },
    tableProducts() {
      return Array.isArray(this.filteredProducts) ? this.filteredProducts : []
    },
    productData() {
      // When API data is loaded for this page, never fall back to worldStore.
      // This prevents stale cached products from rendering when API returns empty.
      if (this.apiData) {
        const products = this.apiData.products || {}
        return {
          products: products,
          reds: this.apiData.reds || {},
          ambers: this.apiData.ambers || {},
          sellerAccounts: this.apiData.sellerAccounts || {},
          watchDogs: {
            inventory: { items: {} },
            buyBox: { items: {} }
          }
        }
      }

      // Before first API response, fall back to worldStore if available.
      if (this.$parent && this.$parent.worldStore && this.$parent.worldStore.products) {
        return this.$parent.worldStore
      }
      return null
    }
  },
  methods: {
    goBack() {
      this.$router.push('/home')
    },
    navigateToProducts() {
      // Already on products page
    },
    navigateToIssues() {
      this.$router.push('/issues')
    },
    navigateToStock() {
      this.$router.push('/stock')
    },
    updateFilters() {
      if (this.$parent && this.$parent.worldStore) {
        this.filterUserCountries = Array.from(new Set(Object.values(this.$parent.worldStore.products).map((i) => i.marketplace)))
        this.filterShowSASelector = (Object.keys(this.$parent.worldStore.sellerAccounts).length > 1)
      }
    },
    openProductDetailModal(productIds, index) {
      if (this.$refs.productDetails) {
        this.$refs.productDetails.open(productIds, index)
      }
    },
    // updateTimeAgo() {
    //   if (!this.lastUpdateTime) {
    //     this.lastUpdated = 'just now'
    //     return
    //   }
      
    //   const now = Date.now()
    //   const diff = Math.floor((now - this.lastUpdateTime) / 1000)
      
    //   if (diff < 60) {
    //     this.lastUpdated = `${diff}s ago`
    //   } else if (diff < 3600) {
    //     const minutes = Math.floor(diff / 60)
    //     this.lastUpdated = `${minutes}m ago`
    //   } else {
    //     const hours = Math.floor(diff / 3600)
    //     this.lastUpdated = `${hours}h ago`
    //   }
    // },
    // startTimer() {
    //   this.lastUpdateTime = Date.now()
    //   this.lastUpdated = 'just now'
      
    //   this.timerInterval = setInterval(() => {
    //     this.updateTimeAgo()
    //   }, 1000)
    // },
    prevPage() {
      const component = this.$refs.productCard
      if (component) component.prevPage()
    },
    nextPage() {
      const component = this.$refs.productCard
      if (component) component.nextPage()
    },
    goToPage(page) {
      const component = this.$refs.productCard
      if (component) component.goToPage(page)
    },
    // Grid pagination methods (server-side)
    prevGridPage() {
      if (this.gridCurrentPage > 0) {
        this.loadProductsFromBackend(this.gridCurrentPage - 1)
      }
    },
    nextGridPage() {
      if (this.gridCurrentPage < this.gridTotalPages - 1) {
        this.loadProductsFromBackend(this.gridCurrentPage + 1)
      }
    },
    goToGridPage(page) {
      if (page >= 0 && page < this.gridTotalPages) {
        this.loadProductsFromBackend(page)
      }
    },
    getGridPageNumber(index) {
      const currentPage = this.gridCurrentPage
      const totalPages = this.gridTotalPages

      if (totalPages <= 5) {
        return index - 1
      }

      const startPage = Math.max(0, currentPage - 2)
      const endPage = Math.min(totalPages - 1, startPage + 4)
      const adjustedStartPage = Math.max(0, endPage - 4)

      return adjustedStartPage + index - 1
    },
    toggleMissingCogsFilter() {
      this.filterMissingCogs = !this.filterMissingCogs
      this.gridCurrentPage = 0 // Reset to first page when filter changes
      this.loadProductsFromBackend(0)
    },
    toggleBuyBoxFilter() {
      this.filterByBuyBox = !this.filterByBuyBox
      this.gridCurrentPage = 0
      this.loadProductsFromBackend(0)
    },
    handleAsinSearch() {
      console.log('ASIN search triggered:', this.asinSearch)
      this.gridCurrentPage = 0 // Reset to first page
      this.loadProductsFromBackend(0)
    },
    clearAsinSearch() {
      this.asinSearch = ''
      this.gridCurrentPage = 0
      this.loadProductsFromBackend(0)
    },
    handleExport() {
      console.log('Export button clicked')
      
      const params = {}
      
      if (this.filterByMarket.length > 0) {
        params.marketplaces = this.filterByMarket.join(',')
      }
      
      if (this.filterBySellAcc.length > 0) {
        params.sellerAccounts = this.filterBySellAcc.join(',')
      }
      
      if (this.filterMissingCogs) {
        params.missingCogs = 'true'
      }
      
      if (this.filterByBuyBox) {
        params.buybox = 'true'
      }
      
      // Add ASIN search
      if (this.asinSearch && this.asinSearch.trim()) {
        params.asin = this.asinSearch.trim()
      }
      
      console.log('Exporting products with filters:', params)
      
      // Build query string
      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')
      
      const exportUrl = '/api/sentinel/products/export' + (queryString ? '?' + queryString : '')
      
      // Show loading state
      this.loadingApiData = true
      
      // Use XMLHttpRequest for blob handling
      const xhr = new XMLHttpRequest()
      xhr.open('GET', exportUrl, true)
      xhr.responseType = 'blob'
      
      xhr.onload = () => {
        this.loadingApiData = false
        this.$nextTick(() => this.initializeDropdowns())

        if (xhr.status === 200) {
          // Create blob URL and trigger download
          const blob = xhr.response
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          
          // Try to get filename from Content-Disposition header, fallback to default
          const contentDisposition = xhr.getResponseHeader('Content-Disposition')
          let filename = `products_export_${new Date().toISOString().split('T')[0]}.csv`
          
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '')
            }
          }
          
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          
          console.log('Export download completed:', filename)
        } else {
          // Try to parse error message
          const blob = xhr.response
          const reader = new FileReader()
          reader.onload = () => {
            let errorMsg = 'Failed to export products. Please try again.'
            try {
              const errorJson = JSON.parse(reader.result)
              errorMsg = errorJson.error || errorMsg
            } catch (e) {
              // Not JSON, use default message
            }
            alert('Error: ' + errorMsg)
          }
          reader.readAsText(blob)
        }
      }
      
      xhr.onerror = () => {
        this.loadingApiData = false
        this.$nextTick(() => this.initializeDropdowns())
        alert('Error: Failed to export products. Please check your connection and try again.')
      }
      
      xhr.send()
    },
    handleImportCogs() {
      console.log('Import COGS button clicked')
      
      const fileInput = document.createElement('input')
      fileInput.type = 'file'
      fileInput.accept = '.csv'
      fileInput.style.display = 'none'
      
      fileInput.onchange = (event) => {
        const file = event.target.files[0]
        if (!file) {
          console.log('No file selected')
          return
        }
        
        console.log('File selected:', file.name)
        
        // Read file as FormData
        const formData = new FormData()
        formData.append('file', file)
        
        // Show loading state
        this.loadingApiData = true
        // POST to import endpoint (FormData sets Content-Type automatically)
        this.$http.post('/api/sentinel/products/import', formData).then((response) => {
          console.log('Import successful:', response)
          this.loadingApiData = false
          // Parse response according to API documentation
          const data = response.body || response.data
          if (data && data.success && data.results) {
            const results = data.results
            const message = `Import completed!\n\n` +
              `Total Rows: ${results.total_rows || 0}\n` +
              `Processed: ${results.processed || 0}\n` +
              `Updated: ${results.updated || 0}\n` +
              `Skipped: ${results.skipped || 0}`
            // Show errors if any
            if (results.errors && results.errors.length > 0) {
              const errorList = results.errors.slice(0, 10).join('\n') // Show first 10 errors
              const moreErrors = results.errors.length > 10 ? `\n... and ${results.errors.length - 10} more errors` : ''
              alert(message + `\n\nErrors:\n${errorList}${moreErrors}`)
            } else {
              alert(message)
            }
          } else {
            // Fallback for different response format
            alert(data && data.message ? data.message : 'COGS imported successfully!')
          }
          this.loadProductsFromBackend(this.gridCurrentPage)
        }, (error) => {
          console.error('Import failed:', error)
          this.loadingApiData = false
          // Parse error response
          let errorMsg = 'Failed to import COGS. Please check the file format and try again.'
          if (error.body) {
            if (error.body.error) {
              errorMsg = error.body.error
            } else if (error.body.message) {
              errorMsg = error.body.message
            }
          } else if (error.message) {
            errorMsg = error.message
          }
          alert('Error: ' + errorMsg)
        })
        // Clean up
        document.body.removeChild(fileInput)
      }
      // Trigger file picker
      document.body.appendChild(fileInput)
      fileInput.click()
    },
    handleCogsUpdated(productId, cogsValue) {
      console.log('COGS updated for product:', productId, 'new value:', cogsValue)
      // Reload the current page to get fresh data from the server
      this.loadProductsFromBackend(this.gridCurrentPage)
    },
    getMarketplaceSuffix(country) {
      return getMarketplaceAmazonSuffix(country)
    },
    showProductDetails(productId) {
      this.saveProductsPageState()
      this.flushProductsRouteQuery()
      var cleanId = String(productId).replace(/^PROD-/i, '')
      this.$router.push({ path: '/product_details', query: buildProductDetailsQuery(cleanId, this.$route.fullPath) })
    },
    flushProductsRouteQuery() {
      if (this._productsUrlTimer) {
        clearTimeout(this._productsUrlTimer)
        this._productsUrlTimer = null
      }
      this.syncProductsRouteQuery()
    },
    buildProductsRouteQuery() {
      const o = {}
      if (this.filterByMarket.length > 0) o.marketplaces = this.filterByMarket.join(',')
      if (this.filterBySellAcc.length > 0) o.sellerAccounts = this.filterBySellAcc.map(String).join(',')
      const qv = (this.asinSearch || '').trim()
      if (qv) o.q = qv
      if (this.filterMissingCogs) o.missingCogs = '1'
      if (this.filterByBuyBox) o.buybox = '1'
      if (this.viewMode && this.viewMode !== 'grid') o.view = this.viewMode
      if (this.gridCurrentPage > 0) o.page = String(this.gridCurrentPage)
      if (this.tableSortKey) {
        o.sort = this.tableSortKey
        o.sortDir = this.tableSortDir || 'desc'
      }
      return o
    },
    syncProductsRouteQuery() {
      if (this._applyingProductsRouteQuery || this.$route.path !== '/products') return
      const next = this.buildProductsRouteQuery()
      if (shallowEqualProductsQuery(next, this.$route.query)) return
      this.$router.replace({ path: '/products', query: next })
    },
    scheduleProductsUrlSync() {
      if (this._productsUrlTimer) clearTimeout(this._productsUrlTimer)
      this._productsUrlTimer = setTimeout(() => {
        this._productsUrlTimer = null
        this.syncProductsRouteQuery()
      }, 400)
    },
    applyProductsRouteQuery(q) {
      if (!q || typeof q !== 'object') return false
      let has = false
      for (let i = 0; i < PRODUCTS_URL_KEYS.length; i++) {
        const k = PRODUCTS_URL_KEYS[i]
        if (q[k] != null && q[k] !== '') {
          has = true
          break
        }
      }
      if (!has) return false

      this._applyingProductsRouteQuery = true
      try {
        if (!Object.prototype.hasOwnProperty.call(q, 'marketplaces')) this.filterByMarket = []
        if (!Object.prototype.hasOwnProperty.call(q, 'sellerAccounts')) this.filterBySellAcc = []
        if (!Object.prototype.hasOwnProperty.call(q, 'q')) this.asinSearch = ''
        if (!Object.prototype.hasOwnProperty.call(q, 'missingCogs')) this.filterMissingCogs = false
        if (!Object.prototype.hasOwnProperty.call(q, 'buybox')) this.filterByBuyBox = false
        if (!Object.prototype.hasOwnProperty.call(q, 'view')) this.viewMode = 'grid'
        if (!Object.prototype.hasOwnProperty.call(q, 'page')) this.gridCurrentPage = 0
        if (!Object.prototype.hasOwnProperty.call(q, 'sort')) {
          this.tableSortKey = 'salesYesterday'
          this.tableSortDir = 'desc'
        }
        if (q.marketplaces !== undefined && q.marketplaces !== null && String(q.marketplaces).length) {
          this.filterByMarket = String(q.marketplaces).split(',').map(s => s.trim()).filter(Boolean)
        }
        if (q.sellerAccounts !== undefined && q.sellerAccounts !== null && String(q.sellerAccounts).length) {
          this.filterBySellAcc = String(q.sellerAccounts).split(',').map(s => {
            const t = s.trim()
            if (!t) return null
            const n = Number(t)
            return isNaN(n) ? t : n
          }).filter(id => id != null && id !== '')
        }
        if (Object.prototype.hasOwnProperty.call(q, 'q')) {
          this.asinSearch = q.q != null && String(q.q).length ? String(q.q) : ''
        }
        if (Object.prototype.hasOwnProperty.call(q, 'missingCogs')) {
          this.filterMissingCogs = q.missingCogs === '1' || q.missingCogs === 'true'
        }
        if (Object.prototype.hasOwnProperty.call(q, 'buybox')) {
          this.filterByBuyBox = q.buybox === '1' || q.buybox === 'true'
        }
        if (q.view === 'table' || q.view === 'grid') this.viewMode = q.view
        if (Object.prototype.hasOwnProperty.call(q, 'page') && q.page !== '' && q.page != null) {
          const p = parseInt(q.page, 10)
          if (!isNaN(p) && p >= 0) this.gridCurrentPage = p
        }
        if (Object.prototype.hasOwnProperty.call(q, 'sort')) {
          this.tableSortKey = q.sort && PRODUCTS_TABLE_SORT_KEYS.indexOf(String(q.sort)) >= 0 ? String(q.sort) : null
        }
        if (q.sortDir === 'asc' || q.sortDir === 'desc') this.tableSortDir = q.sortDir
      } finally {
        this.$nextTick(() => {
          this._applyingProductsRouteQuery = false
        })
      }
      return true
    },
    saveProductsPageState() {
      try {
        const state = {
          asinSearch: this.asinSearch,
          filterByMarket: this.filterByMarket,
          filterBySellAcc: this.filterBySellAcc,
          filterMissingCogs: this.filterMissingCogs,
          filterByBuyBox: this.filterByBuyBox,
          viewMode: this.viewMode,
          gridCurrentPage: this.gridCurrentPage,
          tableSortKey: this.tableSortKey,
          tableSortDir: this.tableSortDir
        }
        localStorage.setItem(PRODUCTS_PAGE_STORAGE_KEY, JSON.stringify(state))
      } catch (e) {
        console.warn('Could not save products page state:', e)
      }
    },
    restoreProductsPageState() {
      try {
        const raw = localStorage.getItem(PRODUCTS_PAGE_STORAGE_KEY)
        if (!raw) return
        const state = JSON.parse(raw)
        if (!state || typeof state !== 'object') return
        if (state.asinSearch != null) this.asinSearch = String(state.asinSearch)
        if (Array.isArray(state.filterByMarket)) {
          this.filterByMarket = state.filterByMarket.filter(m => m != null && m !== '')
        }
        if (Array.isArray(state.filterBySellAcc)) {
          this.filterBySellAcc = state.filterBySellAcc.filter(id =>
            id != null && (typeof id === 'string' || (typeof id === 'number' && !Number.isNaN(id)))
          )
        }
        if (typeof state.filterMissingCogs === 'boolean') this.filterMissingCogs = state.filterMissingCogs
        if (typeof state.filterByBuyBox === 'boolean') this.filterByBuyBox = state.filterByBuyBox
        if (state.viewMode === 'grid' || state.viewMode === 'table') this.viewMode = state.viewMode
        if (typeof state.gridCurrentPage === 'number' && state.gridCurrentPage >= 0) {
          this.gridCurrentPage = state.gridCurrentPage
        }
        if (Object.prototype.hasOwnProperty.call(state, 'tableSortKey')) {
          if (state.tableSortKey === null || PRODUCTS_TABLE_SORT_KEYS.indexOf(state.tableSortKey) >= 0) {
            this.tableSortKey = state.tableSortKey
          }
        }
        if (state.tableSortDir === 'asc' || state.tableSortDir === 'desc') {
          this.tableSortDir = state.tableSortDir
        }
      } catch (e) {
        console.warn('Could not restore products page state:', e)
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0.00'
      return parseFloat(price).toFixed(2)
    },
    calculateMarginValue(product) {
      const margin = this.getProductMargin(product)
      return margin != null ? margin : 0
    },
    calculateMarginFromCogs(cogs, buyBoxPrice) {
      if (!cogs || !buyBoxPrice || buyBoxPrice === 0) return '0'
      const margin = ((buyBoxPrice - cogs) / buyBoxPrice) * 100
      return margin.toFixed(0)
    },
    getMarginClass(margin) {
      if (margin >= 30) return 'high'
      if (margin >= 20) return 'high'
      if (margin >= 10) return 'medium'
      return 'low'
    },
    getAsin(product) {
      if (product.asin) return product.asin
      if (product.productUrl) {
        const match = product.productUrl.match(/\/dp\/([A-Z0-9]+)/i)
        return match ? match[1] : '—'
      }
      return '—'
    },
    getBuyBoxStatus(product) {
      if (!product) return null
      if (product.isSuppressed === true || product.suppressed === true) return 'suppressed'
      if (product.hasBuyBox === true && product.buyBoxWinner === 'you') return 'owned'
      if (product.hasBuyBox === false) return 'lost'
      if (product.buyBoxRotating === true) return 'rotating'
      return null
    },
    getBuyBoxStatusClass(status) {
      if (!status) return ''
      const s = String(status).toLowerCase()
      if (s === 'owned') return 'buybox-owned'
      if (s === 'lost') return 'buybox-lost'
      if (s === 'suppressed') return 'buybox-suppressed'
      if (s === 'rotating') return 'buybox-rotating'
      return ''
    },
    getTableBuyBoxClass(status) {
      if (!status) return ''
      const s = String(status).toLowerCase()
      if (s === 'owned') return 'owned'
      if (s === 'lost') return 'lost'
      if (s === 'suppressed') return 'suppressed'
      if (s === 'rotating') return 'rotating'
      return ''
    },
    getBuyBoxStatusLabel(status) {
      if (!status) return '—'
      const s = String(status).toLowerCase()
      if (s === 'owned') return 'Owned'
      if (s === 'lost') return 'Lost'
      if (s === 'suppressed') return 'Suppressed'
      if (s === 'rotating') return 'Rotating'
      return status
    },
    getBuyBoxStatusText(status) {
      if (!status) return '—'
      const s = String(status).toLowerCase()
      if (s === 'owned') return 'OWNED'
      if (s === 'lost') return 'LOST'
      if (s === 'suppressed') return 'SUPPRESSED'
      if (s === 'rotating') return 'ROTATING'
      return status
    },
    getMarketplaceEmoji(marketplace) {
      const map = { US: '🇺🇸', UK: '🇬🇧', CA: '🇨🇦', DE: '🇩🇪', FR: '🇫🇷', IT: '🇮🇹', ES: '🇪🇸', MX: '🇲🇽', BR: '🇧🇷', IN: '🇮🇳', NL: '🇳🇱', BE: '🇧🇪', SE: '🇸🇪', PL: '🇵🇱', AT: '🇦🇹', ZA: '🇿🇦' }
      return map[marketplace] || '🏳️'
    },
    openCogsModal(product) {
      console.log('Opening COGS modal for product:', product)
      if (!product || !product.productId) {
        console.error('Product or productId is missing')
        alert('Error: Product data is missing')
        return
      }
      // Open the new cost & margin modal
      if (this.$refs.tableProductCostMarginModal) {
        this.$refs.tableProductCostMarginModal.open(product.productId)
      } else {
        console.error('ProductCostMarginModal ref not found')
        alert('Error: Modal component not available')
      }
    },
    handleTableCostMarginUpdated: function (productId) {
      // Reload products from backend after cost/margin update
      this.loadProductsFromBackend(this.gridCurrentPage, this.gridPageSize)
    },
    // Old saveTableCogs and validateCogsInput methods removed - now handled by ProductCostMarginModal component
    tablePrevPage() {
      // Use shared server-side pagination
      if (this.gridCurrentPage > 0) {
        this.loadProductsFromBackend(this.gridCurrentPage - 1)
      }
    },
    tableNextPage() {
      // Use shared server-side pagination
      if (this.gridCurrentPage < this.gridTotalPages - 1) {
        this.loadProductsFromBackend(this.gridCurrentPage + 1)
      }
    },
    goToTablePage(page) {
      // Use shared server-side pagination
      if (page >= 0 && page < this.gridTotalPages) {
        this.loadProductsFromBackend(page)
      }
    },
    getTablePageNumber(index) {
      if (this.gridTotalPages <= 5) {
        return index - 1
      }

      const startPage = Math.max(0, this.gridCurrentPage - 2)
      const endPage = Math.min(this.gridTotalPages - 1, startPage + 4)
      const adjustedStartPage = Math.max(0, endPage - 4)

      return adjustedStartPage + index - 1
    },
    openChartModal(product) {
      // Handle chart modal opening
      if (this.$refs.chartModal) {
        this.$refs.chartModal.open(product, null)
      }
    },
    /** Three-state per column: desc → asc → unsorted (Product starts asc when first selected). Triggers a fresh page-0 fetch. */
    toggleTableSort(column) {
      if (PRODUCTS_TABLE_SORT_KEYS.indexOf(column) === -1) return
      if (this.tableSortKey !== column) {
        this.tableSortKey = column
        this.tableSortDir = column === 'product' ? 'asc' : 'desc'
      } else if (this.tableSortDir === 'desc') {
        this.tableSortDir = 'asc'
      } else if (this.tableSortDir === 'asc') {
        this.tableSortKey = null
        this.tableSortDir = 'desc'
      }
      this.gridCurrentPage = 0
      this.loadProductsFromBackend(0)
    },
    /** "★ 4.2 (1,191)"; "—" when the rating is unknown (null), never "0.0". */
    ratingSummary(rating, count) {
      return ratingSummary(rating, count)
    },
    tableSortHeadClass(column) {
      return {
        'sort-col-active': this.tableSortKey === column,
        'sort-col-asc': this.tableSortKey === column && this.tableSortDir === 'asc',
        'sort-col-desc': this.tableSortKey === column && this.tableSortDir === 'desc'
      }
    },
    loadProductsFromBackend(page = null) {
      // Use provided page or current page
      const currentPage = page !== null ? page : this.gridCurrentPage
      // Build query parameters
      const params = {}
      if (this.filterByMarket.length > 0) {
        params.marketplaces = this.filterByMarket.join(',')
      }
      if (this.filterBySellAcc.length > 0) {
        params.sellerAccounts = this.filterBySellAcc.join(',')
      }
      if (this.filterMissingCogs) {
        params.missingCogs = 'true'
      }
      if (this.filterByBuyBox) {
        params.buybox = 'true'
      }
      // Add ASIN search
      if (this.asinSearch && this.asinSearch.trim()) {
        params.asin = this.asinSearch.trim()
      }
      // Add sorting parameters
      if (this.tableSortKey) {
        params.sortBy = this.tableSortKey
        params.sortDir = this.tableSortDir || 'desc'
      }
      // Add pagination parameters
      params.page = currentPage
      params.pageSize = this.gridPageSize
      // Call backend API with filters and pagination
      params.productsOnly = 'true'
      this.loadingApiData = true
      this.apiError = null
      console.log('Fetching products with filters and pagination:', params)
      this.$http.get('/api/sentinel/products', { params: params }).then((response) => {
        console.log('API Response received:', response.body)
        this.apiData = response.body
        this.loadingApiData = false
        if (response.body.totalItems !== undefined) {
          this.gridTotalItems = response.body.totalItems
          this.gridTotalPages = response.body.totalPages || 1
          this.gridCurrentPage = response.body.currentPage || 0
          this.gridPageSize = response.body.pageSize || 20
        } else if (response.body.summary && response.body.summary.totalProducts !== undefined) {
          // Fallback to summary if root-level pagination not available
          this.gridTotalItems = response.body.summary.totalProducts
          this.gridTotalPages = Math.ceil(response.body.summary.totalProducts / this.gridPageSize)
          this.gridCurrentPage = currentPage
        }
        console.log('Pagination info:', {
          totalItems: this.gridTotalItems,
          totalPages: this.gridTotalPages,
          currentPage: this.gridCurrentPage,
          pageSize: this.gridPageSize
        })
        // Update filter options - always call to see what's available
        console.log('Checking availableFilters:', {
          hasAvailableFilters: !!this.apiData.availableFilters,
          availableFilters: this.apiData.availableFilters
        })
        if (this.apiData.availableFilters) {
          this.updateFilterOptions()
        } else {
          console.warn('No availableFilters in API response - filters will be empty')
          // Extract unique marketplaces and seller IDs from products as fallback
          if (this.apiData.products) {
            const products = Object.values(this.apiData.products)
            const marketplaces = [...new Set(products.map(p => p.marketplace).filter(m => m))]
            const sellerIds = [...new Set(products.map(p => p.sellerId).filter(id => id != null))]
            console.log('Extracted marketplaces from products:', marketplaces)
            this.filterUserCountries = marketplaces
            if (this.filterByMarket.length > 0) {
              this.filterByMarket = this.filterByMarket.filter(m => marketplaces.indexOf(m) >= 0)
            }
            if (this.filterBySellAcc.length > 0 && sellerIds.length > 0) {
              const idSet = new Set(sellerIds.map(id => id != null ? String(id) : null).filter(Boolean))
              this.filterBySellAcc = this.filterBySellAcc.filter(id => idSet.has(String(id)))
            }
          }
        }
        console.log('Products loaded:', Object.keys(this.apiData.products || {}).length)
        console.log('productData computed:', this.productData)
        // Reinitialize dropdowns after data loads to ensure they work
        this.$nextTick(() => this.initializeDropdowns())
      }, (error) => {
        console.error('Error fetching products:', error)
        this.apiError = error.body && error.body.error ? error.body.error : 'Failed to load products'
        this.loadingApiData = false
        // Fall back to old method if API fails
        if (this.$parent && this.$parent.productsList) {
          this.$parent.productsList()
        }
      })
    },
    initializeDropdowns() {
      console.log('initializeDropdowns called', {
        hasSaDropdown: !!this.$refs.saDropdown,
        hasMarketplaceDropdown: !!this.$refs.marketplaceDropdown
      })
      // Initialize seller account dropdown
      if (this.$refs.saDropdown) {
        try { $(this.$refs.saDropdown).dropdown('destroy') } catch (e) { /* not yet initialized */ }
        $(this.$refs.saDropdown).dropdown({
        onChange: (v) => {
            if (this._syncingDropdowns) return
            if (this.loadingApiData) return
            if (v === '') {
              this.filterBySellAcc = []
            } else {
              this.filterBySellAcc = v.split(',').map(Number)
            }
            // Update dropdown text (navbar format: S.Accounts: All)
            const dropdown = $(this.$refs.saDropdown)
            if (v === '') {
              dropdown.find('.text').text('S.Accounts: All')
            } else {
              const selected = v.split(',')
              dropdown.find('.text').text('S.Accounts: ' + (selected.length === 1 ? '1 selected' : selected.length + ' selected'))
            }
            // Reset to first page and load products from backend with filters
            this.gridCurrentPage = 0
            this.loadProductsFromBackend(0)
          },
          placeholder: 'All Accounts',
          fullTextSearch: true
        })
        console.log('Seller account dropdown initialized')
      }
      // Initialize marketplace dropdown
      if (this.$refs.marketplaceDropdown) {
        try { $(this.$refs.marketplaceDropdown).dropdown('destroy') } catch (e) { /* not yet initialized */ }
        $(this.$refs.marketplaceDropdown).dropdown({
        onChange: (v) => {
            if (this._syncingDropdowns) return
            if (this.loadingApiData) return
            if (v === '') {
              this.filterByMarket = []
            } else {
              this.filterByMarket = v.split(',')
            }
            // Update dropdown text (navbar format: Marketplaces: US)
            const dropdown = $(this.$refs.marketplaceDropdown)
            if (v === '') {
              dropdown.find('.text').text('Marketplaces: All')
            } else {
              const selected = v.split(',')
              if (selected.length === 1) {
                dropdown.find('.text').text('Marketplaces: ' + selected[0])
              } else {
                dropdown.find('.text').text('Marketplaces: ' + selected.length + ' selected')
              }
            }
            // Reset to first page and load products from backend with filters
            this.gridCurrentPage = 0
            this.loadProductsFromBackend(0)
          },
          placeholder: 'All Marketplaces',
          fullTextSearch: true
        })
        console.log('Marketplace dropdown initialized')
      }
      this.syncDropdownsToRestoredState()
    },
    syncDropdownsToRestoredState() {
      // Sync Semantic UI dropdown internal state with our restored filter values.
      // Set flag to prevent onChange from triggering loadProductsFromBackend (avoids request loop).
      this._syncingDropdowns = true
      try {
        if (this.$refs.saDropdown && this.filterBySellAcc.length > 0) {
          const val = this.filterBySellAcc.map(String).join(',')
          $(this.$refs.saDropdown).dropdown('set selected', val)
        }
        if (this.$refs.marketplaceDropdown && this.filterByMarket.length > 0) {
          const val = this.filterByMarket.join(',')
          $(this.$refs.marketplaceDropdown).dropdown('set selected', val)
        }
      } catch (e) {
        console.warn('Could not sync dropdowns to restored state:', e)
      } finally {
        // Defer clearing the flag so any async onChange from Semantic UI's 'set selected'
        // still sees it as true and skips triggering loadProductsFromBackend (avoids request loop).
        this.$nextTick(() => {
          setTimeout(() => {
            this._syncingDropdowns = false
          }, 0)
        })
      }
    },
    updateFilterOptions() {
      console.log('updateFilterOptions called', {
        hasAvailableFilters: !!this.apiData.availableFilters,
        availableFilters: this.apiData.availableFilters
      })
      const canonicalOrder = this.filterCountriesAll.filter(c => c !== 's')
      const fromAf = (this.apiData.availableFilters && this.apiData.availableFilters.marketplaces) || []
      let fromProducts = []
      if (this.apiData && this.apiData.products) {
        fromProducts = [...new Set(Object.values(this.apiData.products).map(p => p.marketplace).filter(m => m))]
      }
      const mergedAf = fromAf.length > 0 ? fromAf : fromProducts.map(code => ({ code }))
      this.filterUserCountries = buildMarketplaceFilterCodes({
        fromAvailableFilters: mergedAf,
        v1SellersBody: this.v1SellersApiBody,
        canonicalOrder
      })
      if (this.filterByMarket.length > 0) {
        const mpSet = new Set(this.filterUserCountries)
        this.filterByMarket = this.filterByMarket.filter(m => mpSet.has(m))
      }
      console.log('Updated marketplaces for filter:', this.filterUserCountries)
      const v1Rows = this.v1SellerAccountRows
      const apiSa = this.apiData.availableFilters && this.apiData.availableFilters.sellerAccounts
      let sellerIds = []
      if (v1Rows != null && v1Rows.length > 0) {
        sellerIds = v1Rows.map(r => r.id)
      } else if (v1Rows != null && apiSa && apiSa.length > 0) {
        sellerIds = apiSa.map(sa => sa.id)
      } else if (v1Rows == null && apiSa && apiSa.length > 0) {
        sellerIds = apiSa.map(sa => sa.id)
      }
      if (sellerIds.length > 0) {
        this.filterShowSASelector = sellerIds.length > 1
        if (this.filterBySellAcc.length > 0) {
          const idSet = new Set(sellerIds.map(String))
          this.filterBySellAcc = this.filterBySellAcc.filter(id => idSet.has(String(id)))
        }
        console.log('Seller accounts available:', sellerIds.length)
      } else {
        console.warn('No seller accounts in availableFilters')
        this.filterShowSASelector = false
        this.filterBySellAcc = []
      }
    },
    ensureV1SellerAccountRows() {
      const self = this
      if (self.v1SellerAccountRows !== null) {
        return Promise.resolve(self.v1SellerAccountRows)
      }
      if (self._v1SellersPromise) {
        return self._v1SellersPromise
      }
      self._v1SellersPromise = self.$http.get('/api/v1/sellers').then(
        res => {
          const body = res.body || {}
          self.v1SellersApiBody = body
          const rows = mapV1SellersToFilterAccounts(extractV1SellersItems(body))
          self.v1SellerAccountRows = rows
          return rows
        },
        () => {
          self.v1SellersApiBody = {}
          self.v1SellerAccountRows = []
          return []
        }
      ).finally(() => {
        self._v1SellersPromise = null
      })
      return self._v1SellersPromise
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.path !== '/products') return
      if (this._applyingProductsRouteQuery) return
      if (from && from.path === to.path && shallowEqualProductsQuery(this.buildProductsRouteQuery(), to.query)) return
      const hadUrl = this.applyProductsRouteQuery(to.query)
      if (!hadUrl) {
        this.restoreProductsPageState()
      }
      this.loadProductsFromBackend(this.gridCurrentPage)
    },
    asinSearch() {
      this.saveProductsPageState()
      this.scheduleProductsUrlSync()
    },
    filterByMarket: {
      handler() {
        this.saveProductsPageState()
        this.syncProductsRouteQuery()
      },
      deep: true
    },
    filterBySellAcc: {
      handler() {
        this.saveProductsPageState()
        this.syncProductsRouteQuery()
      },
      deep: true
    },
    filterMissingCogs() {
      this.saveProductsPageState()
      this.syncProductsRouteQuery()
    },
    filterByBuyBox() {
      this.saveProductsPageState()
      this.syncProductsRouteQuery()
    },
    viewMode() {
      this.saveProductsPageState()
      this.syncProductsRouteQuery()
    },
    gridCurrentPage() {
      this.saveProductsPageState()
      this.syncProductsRouteQuery()
    },
    tableSortKey() {
      this.saveProductsPageState()
      this.syncProductsRouteQuery()
    },
    tableSortDir() {
      this.saveProductsPageState()
      this.syncProductsRouteQuery()
    },
    v1SellerAccountRows() {
      if (this.v1SellerAccountRows === null) return
      if (this.apiData && this.apiData.availableFilters) {
        this.updateFilterOptions()
      }
      this.$nextTick(() => this.initializeDropdowns())
    }
  },
  created() {
    const hadUrl = this.applyProductsRouteQuery(this.$route.query)
    if (!hadUrl) {
      this.restoreProductsPageState()
    }
  },
  mounted() {
    // this.startTimer()
    this.ensureV1SellerAccountRows()
    this.updateFilters()
    // Initialize filter dropdowns after DOM is ready
    this.$nextTick(() => {
      this.initializeDropdowns()
    })
    // Load products from backend API
    this.loadProductsFromBackend()
    this.$nextTick(() => {
      this.syncProductsRouteQuery()
    })
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
    if (this._productsUrlTimer) {
      clearTimeout(this._productsUrlTimer)
    }
  }
}
</script>

<style scoped>
.products-pagination-segment {
  margin-top: 20px;
  background-color: var(--bg-light);
  border: 1px solid var(--border-medium);
}

.products-page {
  min-height: 100vh;
  background: var(--bg-white);
  padding: 24px;
}

.products-content {
  max-width: 1400px;
  margin: 0 auto;
}

/* Unified Toolbar */
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: var(--bg-light);
  border-bottom: 1px solid var(--border-light);
  padding: 16px 20px;
  margin-bottom: 20px;
  border-radius: 8px;
}

.toolbar-title-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toolbar-gap {
  flex: 1;
  min-width: 20px;
}

.toolbar-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.stat-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.stat-pill.total {
  background: var(--bg-subtle);
  color: var(--text-secondary);
}

.stat-pill.cogs-ok {
  background: var(--status-success-bg);
  color: var(--status-success);
}

.stat-pill.cogs-missing {
  background: var(--status-warning-bg);
  color: var(--status-warning);
}

/* Header Action Buttons */
.export-btn,
.import-cogs-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid var(--border-medium);
}

.export-btn {
  background: var(--bg-white);
  color: var(--text-primary);
}

.export-btn:hover {
  background: var(--bg-light);
  border-color: var(--text-tertiary);
}

.import-cogs-btn {
  background: var(--status-warning);
  color: var(--bg-white);
  border-color: var(--status-warning);
}

.import-cogs-btn:hover {
  background: var(--accent-orange-hover);
  border-color: var(--accent-orange-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}

.export-btn i.icon,
.import-cogs-btn i.icon {
  margin: 0 !important;
  font-size: 14px;
}

/* Search in toolbar */
.search-wrap {
  position: relative;
  width: 230px;
}

.search-wrap .search-icon {
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	color: var(--text-tertiary);
	pointer-events: none;
}

.search-wrap .search-icon svg {
  width: 18px;
  height: 18px;
}

.search-wrap .search-input,
.search-wrap .asin-search-input {
  width: 100%;
  padding: 8px 12px 8px 32px;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  font-size: 12px;
  font-family: inherit;
  background: var(--bg-light);
  color: var(--text-primary);
  transition: all 0.15s;
}

.search-wrap .search-input:focus,
.search-wrap .asin-search-input:focus {
  outline: none !important;
  border-color: var(--status-info) !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.search-wrap .search-input::placeholder,
.search-wrap .asin-search-input::placeholder {
  color: var(--text-tertiary) !important;
}

.search-wrap .clear-search {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-tertiary);
  cursor: pointer;
  font-size: 16px;
  transition: color 0.2s;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-filter .clear-search:hover {
  color: var(--status-critical);
}

.filter-dropdown {
  min-width: 200px;
  border: 1px solid var(--border-medium);
  border-radius: 6px;
  background: var(--bg-white);
  cursor: pointer;
}

.filter-dropdown .dropdown-trigger {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  gap: 8px;
}

.filter-dropdown .dropdown-trigger i.icon {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
}

.filter-dropdown .dropdown-trigger .text {
  flex: 1;
  color: var(--text-primary);
  font-weight: 500;
  font-size: 14px;
}

.filter-dropdown .dropdown-trigger i.dropdown.icon {
  margin-left: auto;
  color: var(--text-tertiary);
  font-size: 12px;
}

.filter-dropdown .menu {
  border: 1px solid var(--border-light) !important;
  border-radius: 6px !important;
  box-shadow: var(--shadow-md) !important;
  margin-top: 4px !important;
  min-width: 200px !important;
  max-width: 280px !important;
  max-height: min(50vh, 360px) !important;
  background: var(--bg-white) !important;
  z-index: 1000 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
}

.filter-dropdown .menu .item {
  padding: 10px 14px !important;
  color: var(--text-primary) !important;
  font-size: 14px !important;
  display: flex !important;
  align-items: center !important;
  transition: background 0.2s !important;
  position: relative !important;
  cursor: pointer !important;
  white-space: nowrap !important;
}

.filter-dropdown .menu .item:hover {
  background: var(--bg-light) !important;
}

.filter-dropdown .menu .item i.check.icon {
  position: absolute !important;
  left: 10px !important;
  color: var(--status-info) !important;
  font-size: 14px !important;
  margin: 0 !important;
  width: 14px !important;
  height: 14px !important;
}

.filter-dropdown .menu .item.selected {
  padding-left: 32px !important;
  background: var(--status-info-bg) !important;
  color: var(--status-info) !important;
  font-weight: 500 !important;
}

.filter-dropdown .menu .item:not(.selected) {
  padding-left: 14px !important;
}

.filter-dropdown .menu .divider {
  margin: 4px 0 !important;
  border-top: 1px solid var(--border-light) !important;
  height: 0 !important;
}

.filter-dropdown:hover {
  border-color: var(--text-tertiary) !important;
}

.filter-dropdown.active {
  border-color: var(--status-info) !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.filter-dropdown .menu .item i.flag {
  margin-right: 8px !important;
  margin-left: 0 !important;
}

.filter-dropdown .menu .item span {
  margin-left: 0 !important;
}

.quick-filter {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border: 1px solid var(--border-light);
  border-radius: 7px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  background: var(--bg-white);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  font-family: inherit;
}

.quick-filter:hover {
  background: var(--bg-light) !important;
  border-color: var(--text-tertiary) !important;
}

.quick-filter.active {
  background: var(--status-info-bg) !important;
  border-color: var(--status-info) !important;
  color: var(--text-primary) !important;
}

.quick-filter .qf-count {
  margin-left: 4px;
}

.btn-import {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 16px;
	background: var(--accent-orange);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	font-family: inherit;
	transition: all 0.15s;
	box-shadow: 0 2px 8px rgba(245, 132, 31, 0.3);
	white-space: nowrap;
}

.btn-import:hover {
  background: var(--accent-orange-hover);
  border-color: var(--accent-orange-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}

.btn-import svg {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  flex-shrink: 0;
}

/* View Toggle */
.view-toggle {
  display: flex;
  gap: 4px;
  background: var(--bg-subtle);
  padding: 4px;
  border-radius: 6px;
}

.view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background: transparent !important;
  border: none !important;
  border-radius: 4px !important;
  color: var(--text-secondary) !important;
  cursor: pointer;
  transition: all 0.2s !important;
}

.view-btn:hover {
  background: var(--border-light) !important;
  color: var(--text-primary) !important;
}

.view-btn.active {
  background: var(--status-info) !important;
  color: var(--bg-white) !important;
}

.view-btn svg {
  width: 18px;
  height: 18px;
}

.navbar-filters {
  display: flex;
  align-items: center;
  gap: 16px;
}

.navbar-dropdown {
  min-width: 140px;
}

/* Table View */
.table-view {
  background: var(--bg-white);
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.products-table-wrap {
  overflow-x: auto;
}

.products-table-wrap table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.products-table-wrap thead th {
  background: var(--bg-light);
  color: var(--text-primary);
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.5px;
  padding: 16px;
  border-bottom: 2px solid var(--border-light);
  text-align: left;
}

.products-table-wrap thead th.th-img {
  width: 56px;
  padding: 16px 8px;
}

.products-table-wrap thead th.dev-col {
  min-width: 120px;
}

.products-table-wrap thead th:last-child {
  width: 48px;
  padding: 16px 8px;
}

.products-table-wrap thead th.th-sort {
  white-space: nowrap;
}

.products-table-wrap .sort-col-head {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  margin: -4px -6px;
  padding: 4px 6px;
  transition: color 0.15s ease;
}

.products-table-wrap .sort-col-head:hover .sort-icon-neutral {
  opacity: 0.65;
}

.products-table-wrap .sort-col-icons {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.products-table-wrap .sort-icon-neutral {
  width: 14px;
  height: 14px;
  opacity: 0.42;
  flex-shrink: 0;
}

.products-table-wrap .sort-icon-filled {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: var(--primary-navy, #0f2744);
}

.products-table-wrap .sort-col-head.sort-col-active {
  color: var(--primary-navy, #0f2744);
}

.products-table-wrap .sort-col-head:focus {
  outline: 2px solid rgba(59, 130, 246, 0.45);
  outline-offset: 2px;
}

.products-table-wrap tbody tr {
  transition: background 0.2s;
}

.products-table-wrap tbody tr.clickable-row {
  cursor: pointer;
}

.products-table-wrap tbody tr:hover {
  background: #fefce8;
}

.products-table-wrap tbody tr.cogs-missing-row {
  background: #fffbeb;
}

.products-table-wrap tbody tr.cogs-missing-row:hover {
  background: #fef3c7;
}

.products-table-wrap tbody td {
  padding: 16px;
  vertical-align: middle;
  border-bottom: 1px solid var(--border-light);
}

.products-table-wrap .product-thumb {
  width: 48px;
  height: 48px;
  min-width: 48px;
  background: var(--bg-subtle);
  border: 1px solid var(--border-light);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.products-table-wrap .product-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.products-table-wrap .product-thumb svg {
  width: 24px;
  height: 24px;
  color: var(--text-tertiary);
}

.products-table-wrap .product-cell {
  min-width: 0;
}

.products-table-wrap .product-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.products-table-wrap .product-name {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.products-table-wrap .product-meta {
  font-size: 12px;
  color: var(--text-secondary);
}

.products-table-wrap .product-asin {
  margin-right: 6px;
}

.products-table-wrap .market-tag {
  margin-left: 4px;
}

/* bb-badge (table) */
.products-table-wrap .bb-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.products-table-wrap .bb-badge.owned {
  background: var(--status-success-bg);
  color: var(--status-success);
}

.products-table-wrap .bb-badge.lost {
  background: var(--status-warning-bg);
  color: var(--status-warning);
}

.products-table-wrap .bb-badge.suppressed {
  background: var(--status-critical-bg);
  color: var(--status-critical);
}

.products-table-wrap .bb-badge.rotating {
  background: var(--status-info-bg);
  color: var(--status-info);
}

.products-table-wrap .bb-badge.unknown {
  color: var(--text-tertiary);
  background: transparent;
}

/* Rating */
.products-table-wrap .rating-cell {
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
}

.products-table-wrap .rating-cell.rating-unknown {
  color: var(--text-tertiary);
}

.products-table-wrap .rating-alert-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 6px;
  border-radius: 50%;
  background: #ef4444;
  vertical-align: middle;
  cursor: help;
}

/* Sales */
.products-table-wrap .sales-primary {
  font-weight: 500;
  color: var(--text-primary);
}

.products-table-wrap .sales-sub {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 2px;
}

/* COGS */
.products-table-wrap .cogs-val {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
}

.products-table-wrap .cogs-empty {
  color: var(--text-tertiary);
  font-style: italic;
}

.products-table-wrap .add-cogs {
  color: var(--accent-orange);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.products-table-wrap .cogs-val-editable {
  cursor: pointer;
}

.products-table-wrap .cogs-val-editable:hover {
  text-decoration: underline;
  text-decoration-color: rgba(249, 115, 22, 0.45);
}

.products-table-wrap .table-edit-cogs-wrap {
  margin-top: 6px;
}

.products-table-wrap .table-edit-cogs-wrap .add-cogs {
  font-size: 12px;
}

.products-table-wrap .add-cogs:hover {
  color: var(--accent-orange-hover);
  text-decoration: underline;
}

/* Margin pill */
.products-table-wrap .margin-pill {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
}

.products-table-wrap .margin-pill.high {
  background: var(--status-success-bg);
  color: var(--status-success);
}

.products-table-wrap .margin-pill.medium {
  background: var(--status-warning-bg);
  color: var(--status-warning);
}

.products-table-wrap .margin-pill.low {
  background: var(--status-critical-bg);
  color: var(--status-critical);
}

.products-table-wrap .dev-tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 4px;
  font-weight: 600;
}

.products-table-wrap .dev-tag.sp {
  background: var(--status-info-bg);
  color: var(--status-info);
}

.products-table-wrap .dev-tag.user {
  background: var(--bg-subtle);
  color: var(--text-secondary);
}

.products-table-wrap .dev-tag.calc {
  background: var(--status-success-bg);
  color: var(--status-success);
}

.products-table-wrap .dev-tag.missing {
  color: var(--status-warning);
  font-size: 9px;
  font-weight: 700;
}

/* Action button */
.products-table-wrap .action-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--text-tertiary);
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid var(--border-light);
  background: var(--bg-white);
}

.products-table-wrap .action-btn:hover {
  color: var(--text-primary);
}

.products-table-wrap .action-btn svg {
  width: 18px;
  height: 18px;
}
</style>





// WEBPACK FOOTER //
// ProductsPage.vue?2ec013d4